module.exports = __webpack_public_path__ + "img/defaultApproval.6a5e0e45.png";